export default "__VITE_ASSET__DemXRgpq__"